import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { GenderTypeEnum } from "../../../../dtos/catalogs/person/CreatePersonDto";

const PersonDetailMain = () => {
  const Gender = [
    { id: GenderTypeEnum.Male, name: "Male" },
    { id: GenderTypeEnum.Female, name: "Female" }
  ];
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("FirstName")} fieldName={"name"} required />
        </Col>
        <Col sm={3}>
          <NFTextInput title={t("LastName")} fieldName={"lastName"} />
        </Col>
        <Col sm={3}>
          <NFDateInput title={t("CreatedDate")} fieldName={"createdDate"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("FullName")} fieldName={"firstName"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("Tin")} fieldName={"tin"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("Citizenship")} fieldName={"citizenship"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("AddressOfBirth")} fieldName={"addressOfBirth"} />
        </Col>
        <Col sm={6}>
          <NFLookupInput title={t("Gender")} fieldName={"gender"} items={Gender} />
        </Col>
      </Row>
    </>
  );
};

export default PersonDetailMain;
